import React from 'react';
import { Box } from '@mui/material';
import { resolveDelimiterColor } from './journeyMapCanvasUtils';
import { SectionDelimiterRecord } from './journeyMapCanvasTypes';

type Props = {
  backgroundImageUrl?: string | null;
  sectionDelimiters?: SectionDelimiterRecord[];
};

const JourneyMapCanvasOverlay: React.FC<Props> = ({
                                                    backgroundImageUrl = null,
                                                    sectionDelimiters = [],
                                                  }) => {
  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          zIndex: 0,
          backgroundImage: backgroundImageUrl ? `url(${backgroundImageUrl})` : 'none',
          backgroundSize: '100% 100%',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      />

      {backgroundImageUrl ? (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            background: 'rgba(255,255,255,0.72)',
            pointerEvents: 'none',
            zIndex: 1,
          }}
        />
      ) : null}

      {sectionDelimiters.map((delimiter) => {
        const lineColor = resolveDelimiterColor(delimiter.color);
        const lineWidth = delimiter.width ?? 2;
        const lineStyle = delimiter.lineStyle ?? 'solid';
        const isVertical = (delimiter.orientation || 'vertical') === 'vertical';

        return (
          <Box
            key={delimiter.tempId}
            sx={{
              position: 'absolute',
              ...(isVertical
                ? {
                  top: 0,
                  bottom: 0,
                  left: `${delimiter.x ?? 300}px`,
                  width: 0,
                  borderLeft: `${lineWidth}px ${lineStyle} ${lineColor}`,
                }
                : {
                  left: 0,
                  right: 0,
                  top: `${delimiter.y ?? 180}px`,
                  height: 0,
                  borderTop: `${lineWidth}px ${lineStyle} ${lineColor}`,
                }),
              zIndex: 2,
              pointerEvents: 'none',
            }}
          >
            {delimiter.label ? (
              <Box
                sx={{
                  position: 'absolute',
                  ...(isVertical
                    ? {
                      top: 12,
                      left: 10,
                    }
                    : {
                      top: -34,
                      left: 12,
                    }),
                  px: 1,
                  py: 0.5,
                  borderRadius: 1,
                  backgroundColor: '#fff',
                  border: `1px solid ${lineColor}`,
                  color: '#23282E',
                  fontSize: 12,
                  fontWeight: 700,
                  whiteSpace: 'nowrap',
                  boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
                }}
              >
                {delimiter.label}
              </Box>
            ) : null}
          </Box>
        );
      })}
    </>
  );
};

export default JourneyMapCanvasOverlay;